import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDocs } from "../../../../hooks/useDocs";
import { useSlack } from "../../../../hooks/useSlack";
import { useAuth } from "../../../../hooks/useAuth";
import { emitToast } from "../../../../common/toastEmitter";
import { useNavigate } from "react-router-dom";

export default function LinearStepper({
  children,
  activeStep,
  setActiveStep,
  asset,
  resetAsset,
  steps,
  disabled = false,
}) {
  const [skipped, setSkipped] = React.useState(new Set());
  const { addDocument, updateAsset } = useDocs("vtec_assets");
  const { genericSlack } = useSlack();
  const { user } = useAuth();
  const navigate = useNavigate();

  const isStepOptional = (step) => {
    return false;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = async () => {
    try {
      if (asset.hasOwnProperty("id")) {
        await updateAsset(asset, user);
        genericSlack(`Updated asset ${asset.id} : ${asset.Title}`);
        emitToast("Asset Updated Succcesfully.", "success");
      } else {
        const addedDoc = await addDocument(asset, user);
        genericSlack(`Added asset ${addedDoc.id} : ${addedDoc.Title}`);
        emitToast("Asset Created Succcesfully.", "success");
      }

      resetAsset();
      setActiveStep(0);
      navigate("/assets");
    } catch (error) {
      console.error("Error handling reset:", error);
      emitToast("An error occurred while resetting the asset.", "error");
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {children}
      {activeStep === steps.length ? (
        <React.Fragment>
          <Box sx={{ display: "flex", flexDirection: "row", py: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleReset}>Submit</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Box sx={{ display: "flex", flexDirection: "row", py: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />

            <Button onClick={handleNext} disabled={disabled}>
              {activeStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}
